import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

/**
 * Shared panel shell for overview sections.
 */
export default function OverviewPanel({
  title,
  description,
  icon: Icon,
  children,
  footerHref,
  footerLabel,
  headerActions,
  className = '',
  variant = 'default',
}) {
  const cls = [
    'overview-panel',
    variant === 'ai' ? 'overview-panel--ai' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={cls}>
      <div className="overview-panel-header">
        <div>
          <h3 className="overview-panel-title">
            {Icon ? <Icon size={16} strokeWidth={2} aria-hidden /> : null}
            {title}
          </h3>
          {description ? <p className="overview-panel-desc">{description}</p> : null}
        </div>
        {headerActions ? <div className="overview-panel-actions">{headerActions}</div> : null}
      </div>
      {children}
      {footerHref ? (
        <Link to={footerHref} className="overview-link-footer">
          {footerLabel || 'Open'}
          <ChevronRight size={14} aria-hidden />
        </Link>
      ) : null}
    </div>
  )
}

export function BandHeading({ title, subtitle, badge }) {
  return (
    <div className="overview-band-heading">
      <div className="overview-band-heading-row">
        <h2 className="overview-band-title">{title}</h2>
        {badge ? <span className="overview-band-badge">{badge}</span> : null}
      </div>
      {subtitle ? <p className="overview-band-subtitle">{subtitle}</p> : null}
    </div>
  )
}
